import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/Badge'
import { formatMoney } from '@/utils/format'
import { isPositiveAmount } from '../status'
import type { Loan } from '../types'

/** Recorded fine (paid / outstanding) or the fine accruing on an overdue loan. */
export function FineCell({ loan, currency }: { loan: Loan; currency: string }) {
  const { t } = useTranslation('library')
  if (loan.state === 'overdue' && isPositiveAmount(loan.accruedFine)) {
    return (
      <span className="text-danger-700 tabular" title={t('Accruing — recorded when the book is returned')}>
        {formatMoney(loan.accruedFine, currency)} <span className="text-2xs text-muted">{t('so far')}</span>
      </span>
    )
  }
  if (!isPositiveAmount(loan.fineAmount)) return <span className="text-subtle">—</span>
  return (
    <span className="inline-flex items-center gap-1.5 tabular">
      {formatMoney(loan.fineAmount, currency)}
      <Badge tone={loan.finePaid ? 'success' : 'warning'} size="sm">
        {loan.finePaid ? t('Paid') : t('Unpaid')}
      </Badge>
    </span>
  )
}
